export const routes = {
  home: '/',
  login: '/login',
  signup: '/signup',
  remember: '/remember',
  error: '/error',
};
